module.exports = __webpack_public_path__ + "static/media/mazya final edit shot 02.37a26774.webp";